<template>
  <div v-if="loaded" class="profile">
    <profile-image
      v-if="profileImage"
      :src="profileImageSrc"
      :alt="fullName"
    ></profile-image>
    <profile-details
      :name="fullName"
      :organization="organization.name"
    ></profile-details>
  </div>
</template>
<script>
import profile from "@/mixins/profile";
import ProfileImage from "./ProfileImage.vue";
import ProfileDetails from "./ProfileDetails.vue";
import { toDataUrl } from "@/util/htmlUtil";

export default {
  components: { ProfileImage, ProfileDetails },
  mixins: [profile],
  data: function() {
    return {
      organization: null,
      profileImage: null,
      loaded: false,
    };
  },
  computed: {
    fullName: function() {
      return this.profile.fullName;
    },
    profileImageSrc: function() {
      if (this.profileImage) {
        return toDataUrl(
          this.profileImage.contents,
          this.profileImage.mimeType
        );
      }

      return "";
    },
  },
  // Vue 3: $on removed, use watch or direct method call instead
  watch: {
    profileLoaded: {
      handler: async function(loaded) {
        if (loaded) {
          this.organization = await this.getOrganization();
          this.profileImage = await this.getProfileImage();
          this.loaded = true;
        }
      },
      immediate: true
    }
  },
};
</script>
<style lang="scss" scoped>
.profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
